import { HttpClient } from "@angular/common/http";
import { Inject, Injectable } from "@angular/core";
import { API_BASE_URI } from "../../http/api";
import { Observable } from "rxjs";
import { DetailRequest, DetailRequestBuilder } from "../../http/detail";
import { NewPageOption, ReportPageOption } from "@core/data/types/advanced-report";
import { ReportHttpHelperService } from "./advanced-report-http-helper.service";

@Injectable()
export class ReportPageOptionService {

    constructor(
        @Inject(API_BASE_URI) private _baseUri: string,
        private _http: HttpClient,
        private _httpHelperService: ReportHttpHelperService,
    ) {}

    get(key: string, shareKey: string, detail?: DetailRequest): Observable<ReportPageOption> {
        const params = detail ? DetailRequestBuilder.queryParams(detail) : {};
        return this._http.get<ReportPageOption>(`${this._baseUri}/report-page/option/${key}`, this._httpHelperService.withShareKey({params}, shareKey));
    }

    create(model: NewPageOption): Observable<ReportPageOption> {
        return this._http.post<ReportPageOption>(`${this._baseUri}/report-page/option`, model);
    }

    update(key: string, model: ReportPageOption): Observable<ReportPageOption> {
        return this._http.put<ReportPageOption>(`${this._baseUri}/report-page/option/${key}`, model);
    }
}